<div mat-dialog-title>
  <span>{{'stations.configuredGraphs.modal.modalColor.title' | translate}}</span>
</div>
<div class="badge__ctn">
  <mat-dialog-content>
    <!-- Badge assignment -->
    <form [formGroup]="detailForm" (keydown.enter)="$event.preventDefault()">
      @if (tags) {
        <div class="form-group w-100 mb-10">
          <label for="tag">{{'stations.configuredGraphs.modal.modalColor.selectTag' | translate}}</label>
          <select name="" title="tag" formControlName="tag" class="form-control" id="tag" placeholder="tag" (change)="onTagSelected($event)">
            @for (t of tags; track t) {
              <option [ngValue]="t"
                class="text-capitalize">
                {{t.name}}
              </option>
            }
          </select>
        </div>
      }
      <h2 class="detail-title">{{'stations.configuredGraphs.modal.modalColor.configSerie' | translate}}</h2>
      <div class="form-group w-100 mb-10">
        <label for="existingBadge">{{'stations.configuredGraphs.modal.modalColor.color' | translate}}</label>
        <input type="color"  class="form-control" formControlName="color" id="color">
      </div>

      <div class="form-group w-100 mb-10">
        <label for="number">{{'stations.configuredGraphs.modal.modalColor.width' | translate}}</label>
        <input type="number"  class="form-control" formControlName="width" id="width">

      </div>
      <div class="form-group w-100 mb-10">
        <label for="number">{{'stations.configuredGraphs.modal.modalColor.type' | translate}}</label>
        <select name="" title="type" formControlName="type" class="form-control" id="type" placeholder="type">
          @for (lineType of LineTypes; track lineType) {
            <option [ngValue]="lineType"
              class="text-capitalize">
              {{ "stations.configuredGraphs.lineType." + lineType | translate}}
            </option>
          }
        </select>
      </div>
      <h2 class="detail-title">{{'stations.configuredGraphs.modal.modalColor.configAxis' | translate}}</h2>
      @if (yAxis.length > 0 && !newAxisMode) {
        <div>
          <div class="form-group">
            <label for="yAxisSelect" class="required">{{'stations.configuredGraphs.modal.modalColor.type' | translate}}</label>
            <select name="" title="yAxis" formControlName="yAxisSelect" class="form-control" id="yAxisSelect" placeholder="yAxisSelect">
              @for (yAxi of yAxis; track yAxi) {
                <option [ngValue]="yAxi.index"
                  class="text-capitalize">
                  {{ yAxi.name}}
                </option>
              }
            </select>
          </div>
          @if (axisUpdate == false) {
            <div class="newAxisContainer" (click)="onToggleAxisMode()">
              <span class="">{{'stations.configuredGraphs.modal.modalColor.createNewAxis' | translate}}</span>
            </div>
          }
        </div>
      }
      @if (yAxis.length === 0 || newAxisMode) {
        <div>
          <div class="form-group w-100 mb-10">
            <label for="yAxisName" class="required">{{'stations.configuredGraphs.modal.modalColor.name' | translate}}</label>
            <input class="form-control" formControlName="yAxisName" id="yAxisName">
          </div>
          <div class="form-group w-100 mb-10">
            <label for="yAxisColor">{{'stations.configuredGraphs.modal.modalColor.colorAxis' | translate}}</label>
            <input type="color"  class="form-control" formControlName="yAxisColor" id="yAxisColor">
          </div>
          <div class="form-group minMax mb-10">
            <div class="form-group">
              <label for="min">{{'stations.configuredGraphs.modal.modalColor.min' | translate}}</label>
              <input type="number"  class="form-control" formControlName="min" id="min">
            </div>
            <div class="form-group">
              <label for="max">{{'stations.configuredGraphs.modal.modalColor.max' | translate}}</label>
              <input type="number"  class="form-control" formControlName="max" id="max">
            </div>
          </div>
          <div class="form-group w-100 mb-10">
            <label for="position">{{'stations.configuredGraphs.modal.modalColor.position' | translate}}</label>
            <select name="" title="position" formControlName="position" class="form-control" id="position" placeholder="position">
              @for (yAxisPosition of yAxisPositions; track yAxisPosition) {
                <option [ngValue]="yAxisPosition"
                  class="text-capitalize">
                  {{'stations.configuredGraphs.modal.modalColor.' + yAxisPosition | translate}}
                </option>
              }
            </select>
          </div>
          @if (yAxis.length > 0 && axisUpdate == false) {
            <div class="newAxisContainer" (click)="onToggleAxisMode()">
              <span class="">{{'stations.configuredGraphs.modal.modalColor.selectExistingAxis' | translate}}</span>
            </div>
          }
        </div>
      }
    </form>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button class="btn btn--primary" type="submit" (click)="onSubmit()">{{'action.submit' | translate}}</button>
    <button mat-dialog-close class="btn btn--outline-grey-color ml-20">{{'action.cancel' | translate}}
    </button>
  </div>
</div>